function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#1F2947",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.5 33h-14a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2zM28.5 11h-17a1 1 0 0 0 0 2h17a1 1 0 0 0 0-2zM20 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM26.5 15h-15a1 1 0 0 0 0 2h15a1 1 0 0 0 0-2zM28.5 19h-17a1 1 0 0 0 0 2h17a1 1 0 0 0 0-2zM28.5 24h-17a1 1 0 0 0 0 2h15.84l.29-.42.24-.34.42-.61.27-.39.15-.22h-.21V24zM21.5 28h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35.44 12.68-.38.55-1 1.43-.06.09-.16.23-.58.81-.82 1.21-.44.63-.22.32-2.33 3.33-.32.45-.38.55-.28.4-.95 1.32-.17.24-.2.29-.5.71-.17.24-.36.52-3.3 4.7 2.45 1.72 4.65-6.64.38-.54.29-.41.41-.59.91-1.3.08-.11.58-.83L34 20l.06-.09 1-1.44.65-.93.58-.81 1.6-2.29-2.45-1.76zm0 3.44-.41.59-.16.23-.84 1.2-.06.09-2 2.86-.12.17-.44.63-.25.35-.42.6-1 1.4-.33.48-.35.51-.31.44-.22.31L25 31l-.82-.57L27.34 26l.29-.42.24-.34.42-.61.27-.39.15-.22.9-1.28.35-.5.32-.45.39-.55 1.33-1.9.93-1.34.65-1 .42-.59.06-.08.57-.81.41-.59.62-.88.83.57-1.05 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.82 30.7-.26 2.99 2.72-1.27-2.46-1.72zM36.29 16.7l-.57.82-.01-.01-.65-.45-.16-.12-.82-.58-.02-.01-.8-.56.57-.81h.01l.22.16.59.41.41.29.41.28z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 1H9a3 3 0 0 0-3 3v32a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V18.23l-2 2.86V36a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v15.34l.93-1.34.65-1 .42-.59V4a3 3 0 0 0-3-3z"
}));
const SvgNewSigning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewSigning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-signing.4ddcf202.svg";
export { ForwardRef as ReactComponent };